import React, { useState } from 'react';
import { Shield, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Shared "how does my credibility score work" disclosure -- originally built
// inline on profile.jsx (fifty-ninth pass, credibility-score transparency),
// extracted here so the composer can show the exact same, already-correct
// copy instead of drifting into its own paraphrase over time (the same
// class of doc/copy drift this engagement has repeatedly found and fixed
// elsewhere -- see Technical_Docs/13_FIX_HISTORY.md's sixty-fourth pass).
// Collapsed by default everywhere it's used so it doesn't add noise to a
// screen most visits just glance at.
const CredibilityExplainer = ({ label = null, className = '' }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const resolvedLabel = label ?? t('credibility.explainer.defaultLabel');
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 text-sm font-medium text-blue-700 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition"
      >
        {open ? <X className="w-3.5 h-3.5" /> : <Shield className="w-3.5 h-3.5" />}
        {resolvedLabel}
      </button>
      {open && (
        <ul className="mt-3 space-y-2 text-sm text-gray-600 dark:text-slate-300 bg-cream-100 dark:bg-white/5 rounded-xl p-4 border border-cream-300 dark:border-white/10">
          <li className="flex gap-2">
            <span className="text-blue-700 dark:text-blue-400 font-semibold">1.</span>
            <span>
              <strong className="text-gray-800 dark:text-white">{t('credibility.explainer.item1Title')}</strong> {t('credibility.explainer.item1Body')}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="text-blue-700 dark:text-blue-400 font-semibold">2.</span>
            <span>
              <strong className="text-gray-800 dark:text-white">{t('credibility.explainer.item2Title')}</strong> {t('credibility.explainer.item2Body')}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="text-blue-700 dark:text-blue-400 font-semibold">3.</span>
            <span>
              <strong className="text-gray-800 dark:text-white">{t('credibility.explainer.item3Title')}</strong> {t('credibility.explainer.item3Body')}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="text-blue-700 dark:text-blue-400 font-semibold">4.</span>
            <span>
              <strong className="text-gray-800 dark:text-white">{t('credibility.explainer.item4Title')}</strong> {t('credibility.explainer.item4Body')}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="text-blue-700 dark:text-blue-400 font-semibold">5.</span>
            <span>
              <strong className="text-gray-800 dark:text-white">{t('credibility.explainer.item5Title')}</strong> {t('credibility.explainer.item5Body')}
            </span>
          </li>
          <li className="flex gap-2 pt-1 border-t border-cream-300 dark:border-white/10">
            <span className="text-amber-700 dark:text-amber-400 font-semibold">!</span>
            <span>{t('credibility.explainer.decayNote')}</span>
          </li>
        </ul>
      )}
    </div>
  );
};

export default CredibilityExplainer;
